export default "__VITE_ASSET__CwDyJOBb__"